<template>
  <div>
    <!--暂停服务弹窗-->
    <div
      class="toast-bg"
      v-show="noticeFlag"
    >
      <div class="toast-me middle">
        <div class="toast-tit">系统维护通知</div>
        <hr class="toast-line" />
        <div class="toast-main toast-main2">
          <div
            class="toast-text"
            v-html="noticeMessage"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import api from "../common/utils/api";
import http from "axios";

export default {

  data() {
    return {
      noticeFlag: false, //暂停服务配置
      noticeMessage: "",
    };
  },

  methods: {
    /**
     * 获取暂停服务配置
     */
    getSystemNotice() {
      let url = api.reservation.getSystemNotice();
      http({
        method: "get",
        url: url,
        params: {},
      }).then((res) => {
        if (res.data.stateCode == 1) {
          this.noticeFlag = res.data.data.pauseFlag
          this.noticeMessage = res.data.data.pauseMessage
        }
      });
    },
  },
  mounted: function () {
    this.getSystemNotice()
  },



};
</script>
<style>
@import url("../assets/css/common.css");
@import url("../assets/css/index.css");
.reg-product {
  text-decoration: underline #00b0ec;
  color: #00b0ec;
  font-size: 15px;
  margin-top: 10px;
  cursor: pointer;
}
.select-wrap2 {
  width: 53rem;
}

.select-wrap select {
  width: 11rem;
  border: 1px solid rgba(216, 221, 225, 1);
  height: 56px;
  line-height: 56px;
  padding-left: 10px;
  font-size: 15px;
  color: #576371;
  overflow-y: scroll;
}
.vercode {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #0190e1;
  cursor: pointer;
}

.vercode_disable {
  display: inline-block;
  line-height: 50px;
  width: 124px;
  height: 52px;
  text-align: center;
  color: white;
  font-size: 15px;
  background: #a4a4a4;
  cursor: pointer;
}
.qrcode-img {
  width: 150px;
  height: 150px;
}
</style>
